import { render } from "./IsContributor.vue?vue&type=template&id=93b2dc12&scoped=true"
import script from "./IsContributor.vue?vue&type=script&lang=js"
export * from "./IsContributor.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b2dc12"]])

export default __exports__